import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitodamantaxi() {



const cardData = {
  keyword: "Mumbai to Daman Taxi",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Daman taxi services for travelers seeking a smooth and convenient journey to this coastal destination. Whether you are planning a weekend getaway, family trip, romantic outing, or group excursion, our cab service ensures a safe and hassle-free ride with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Daman taxi services.",

topPlaces: [
  {
    title: "Devka Beach",
    description:
      "Devka Beach is a popular destination in Daman known for its sandy shores, calm waters, and lively promenade. Visitors can enjoy evening walks, local snacks, photography, and family outings. Traveling by taxi ensures a comfortable journey from Mumbai and allows sufficient time to explore the beach and nearby attractions without transport concerns."
  },
  {
    title: "Jampore Beach",
    description:
      "Jampore Beach is famous for its clean coastline, water activities, and serene environment. Visitors can relax, enjoy beach sports, and indulge in photography. A taxi ride provides hassle-free access, allowing tourists to spend quality time at this scenic location along with other Daman sightseeing spots."
  },
  {
    title: "Daman Fort",
    description:
      "Daman Fort is a historic Portuguese fort offering panoramic views of the Arabian Sea and the city. Visitors can explore the fortifications, learn about its history, and enjoy scenic photography. Traveling by taxi ensures convenient access, making it easy to integrate the fort into a full day of sightseeing."
  },
  {
    title: "Moti Daman Fort",
    description:
      "Moti Daman Fort is one of Daman’s prominent historical landmarks featuring bastions, churches, and museums within its premises. Visitors can explore architecture, capture photographs, and enjoy the peaceful surroundings. A taxi service provides comfortable travel from Mumbai and allows sufficient time for exploration."
  },
  {
    title: "St. Jerome Fort",
    description:
      "St. Jerome Fort is a lesser-known historic fort in Daman with rich Portuguese heritage and scenic views. Visitors can enjoy photography, heritage walks, and the tranquil environment. Traveling by taxi ensures easy access and flexibility to include this site along with other sightseeing destinations."
  },
  {
    title: "Church of Bom Jesus",
    description:
      "Church of Bom Jesus in Daman showcases Portuguese architecture, religious significance, and serene surroundings. Visitors can attend prayers, admire the architecture, and capture photographs. A taxi ride ensures hassle-free access from Mumbai, making it easier to plan a spiritual or cultural visit."
  },
  {
    title: "Jampore Nature Walks",
    description:
      "The Jampore area offers nature trails and scenic walks along the beach and cliffs. Visitors can enjoy early morning walks, birdwatching, and photography. Traveling by taxi provides comfortable and safe access, allowing ample time to explore the natural beauty of Daman."
  },
  {
    title: "Nani Daman Beach",
    description:
      "Nani Daman Beach is ideal for quiet reflection, photography, and leisurely strolls. Visitors can enjoy the calm sea, nearby eateries, and peaceful environment. A taxi service allows convenient transport from Mumbai, enabling travelers to include this location in their Daman itinerary effortlessly."
  },
  {
    title: "Daman Ganga Tourist Complex",
    description:
      "The Daman Ganga Tourist Complex offers recreational facilities, gardens, and viewpoints near the river. Visitors can relax, take photographs, and enjoy family outings. Traveling by taxi ensures hassle-free access and flexibility to explore multiple attractions in one trip."
  },
  {
    title: "Local Daman Market",
    description:
      "Daman’s local markets are perfect for shopping handicrafts, souvenirs, and tasting regional snacks. Visitors can experience local culture, shop, and enjoy street food. A taxi ride from Mumbai ensures convenient travel, allowing tourists to combine shopping with sightseeing efficiently."
  }
],




services: [
{
name: "Mumbai to Daman Cab",
description: "Mumbai to Daman cab service provides comfortable and reliable intercity transportation for travelers planning a trip to the beautiful coastal town of Daman. Our fleet includes AC sedans, SUVs, and premium vehicles designed for smooth highway travel along the western coastal route. Professional drivers ensure safe driving and timely arrival at your destination. Pickup services are available from homes, hotels, offices, railway stations, and Mumbai airport terminals. Ideal for weekend trips, family vacations, and leisure travel. Spacious seating and air-conditioned interiors ensure relaxed travel throughout the journey. Flexible one-way and round-trip options allow convenient travel planning. Transparent pricing ensures a smooth and stress-free cab booking experience."
},
{
name: "Mumbai to Daman Taxi",
description: "Mumbai to Daman taxi service offers convenient and comfortable road travel between Mumbai and the scenic beach destination of Daman. AC vehicles provide pleasant travel conditions throughout the journey. Experienced drivers ensure safe highway driving and punctual arrival at the destination. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for tourists, family outings, and short holiday trips. Clean interiors and spacious seating provide a comfortable travel experience. Flexible departure schedules allow travelers to plan trips easily. Reliable taxi services ensure safe and smooth intercity travel."
},
{
name: "Mumbai to Daman Cab Service",
description: "Mumbai to Daman cab service offers dependable transportation for travelers visiting the popular coastal getaway of Daman. Our well-maintained AC vehicles ensure smooth highway journeys and comfortable seating. Professional drivers ensure safe driving and timely arrival at the destination. Pickup services are available from residential areas, hotels, offices, and airport terminals across Mumbai. Ideal for weekend beach trips, tourism travel, and family vacations. Spacious interiors provide comfortable seating during the journey. Flexible booking options allow passengers to schedule trips conveniently. Transparent pricing ensures reliable cab service."
},
{
name: "Mumbai to Daman Taxi Service",
description: "Mumbai to Daman taxi service provides efficient and comfortable travel for passengers planning a coastal getaway. Our fleet includes AC sedans and SUVs suitable for long and short distance journeys. Skilled drivers ensure safe driving along the highway route connecting Mumbai and Daman. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for leisure travel, tourism visits, and family holidays. Spacious seating ensures passenger comfort throughout the journey. Flexible travel timing allows convenient trip planning. Affordable fares ensure smooth taxi travel."
},
{
name: "Cab from Mumbai to Daman",
description: "Cab from Mumbai to Daman offers private and comfortable transportation for travelers planning beach vacations or weekend trips. AC vehicles ensure smooth and pleasant highway travel. Professional drivers ensure safe driving and reliable service throughout the journey. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for families, tourists, and leisure travelers. Spacious interiors provide relaxed seating for passengers. Flexible departure timing allows convenient trip planning. Reliable cab services ensure stress-free travel."
},
{
name: "Taxi from Mumbai to Daman",
description: "Taxi from Mumbai to Daman provides dependable road travel for passengers visiting the popular coastal tourist destination. Comfortable AC vehicles ensure pleasant travel conditions throughout the journey. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourists, couples, and family vacation trips. Clean interiors and spacious seating provide comfortable journeys. Flexible scheduling allows travelers to plan trips easily. Professional taxi services ensure reliable intercity travel."
},
{
name: "Mumbai to Daman Cab Booking",
description: "Mumbai to Daman cab booking allows passengers to reserve vehicles quickly for coastal travel and weekend trips. Online and phone booking options provide instant confirmation and convenient scheduling. Comfortable AC sedans and SUVs ensure smooth highway journeys. Professional drivers ensure punctual pickup and safe driving throughout the trip. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourism travel, family holidays, and leisure trips. Flexible one-way and round-trip booking options are available. Reliable booking services ensure hassle-free travel planning."
},
{
name: "Mumbai to Daman Taxi Booking Online",
description: "Mumbai to Daman taxi booking online provides fast and convenient reservations for passengers planning a coastal getaway. Instant booking confirmation allows travelers to schedule trips easily. Comfortable AC vehicles ensure relaxed travel conditions throughout the journey. Experienced drivers ensure safe and professional driving services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for families, tourists, and weekend travelers. Flexible travel timing allows convenient trip scheduling. Reliable booking systems ensure smooth taxi reservations."
},
{
name: "Mumbai to Daman Cab Price",
description: "Mumbai to Daman cab price offers transparent and affordable travel options for passengers planning coastal trips. Clear pricing details help travelers understand the total journey cost before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for different travel needs. Comfortable seating and AC interiors ensure relaxed travel conditions. Professional drivers ensure safe highway travel and punctual arrival. Pickup services are available across Mumbai including airport terminals. Flexible travel options allow passengers to choose one-way or round-trip journeys. Budget-friendly fares ensure convenient cab travel."
},
{
name: "Mumbai to Daman Taxi Fare",
description: "Mumbai to Daman taxi fare is calculated with transparent per-kilometer pricing to provide clear travel costs. Passengers can select vehicles depending on comfort and budget preferences. Our AC vehicles ensure smooth highway travel between the two destinations. Experienced drivers ensure safe driving and punctual arrival. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for family trips and tourism travel. Flexible booking options allow easy travel planning. Reliable fare structure ensures stress-free taxi booking."
},
{
name: "Mumbai to Daman One Way Cab",
description: "Mumbai to Daman one way cab service is ideal for travelers who require a drop service without paying return charges. This option helps reduce overall travel expenses while ensuring comfortable transportation. AC sedans and SUVs provide relaxed seating for highway travel. Professional drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for weekend travelers and tourism trips. Flexible departure timing allows convenient scheduling. Reliable one-way cab service ensures affordable travel."
}
],

tableData: [
["Mumbai to Daman Cab","Mumbai to Daman Taxi"],
["Mumbai to Daman Cab Service","Mumbai to Daman Taxi Service"],
["Cab from Mumbai to Daman","Taxi from Mumbai to Daman"],
["Mumbai to Daman Cab Booking","Mumbai to Daman Taxi Booking Online"],
["Mumbai to Daman Cab Price","Mumbai to Daman Taxi Fare"],
["Mumbai to Daman One Way Cab","Best Cab Mumbai to Daman"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Coastal Route Drivers",
    WhyChoosedescription: "Our drivers are experienced with the Mumbai to Daman coastal highway routes via NH48 and coastal roads. They understand the best travel routes, traffic patterns, and scenic stops, ensuring a smooth and safe journey to this popular beach destination."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Mumbai to Daman taxi bookings. We clearly explain per-kilometer fares, toll charges, and travel packages before confirming your booking so there are no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you want to travel early in the morning or late at night, Omshree Cabs offers 24/7 taxi booking and customer support for your Mumbai to Daman trip."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized. This ensures a comfortable and relaxing ride for beach travel."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We provide flexible travel options including one-way cabs, round-trip taxi services, and same-day return packages for Mumbai to Daman journeys."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for couples, families, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and airports anywhere in Mumbai so your journey to Daman begins smoothly without travel stress."
  },
  {
    WhyChooseheading: "Reliable Beach Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by travelers for Mumbai to Daman trips. Our punctual drivers, comfortable vehicles, and professional service ensure a relaxing coastal travel experience."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Daman by taxi?", answer: "The distance from Mumbai to Daman is approximately 170 km and the journey usually takes around 3–4 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Daman taxi services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip taxi services between Mumbai and Daman." },
  { question: "Which vehicles are available for Mumbai to Daman travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort preference." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport or any location in Mumbai for Daman taxi bookings." },
  { question: "Can we stop during the journey for meals or sightseeing?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or short sightseeing breaks." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Do you offer same-day return packages to Daman?", answer: "Yes, same-day return taxi packages from Mumbai to Daman are available." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday seasons when Daman receives many tourists." },
  { question: "Do you provide group travel options?", answer: "Yes, SUVs and larger vehicles are available for family and group trips from Mumbai to Daman." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Jayesh Shah",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Daman beach trip. The driver was punctual and the car was very clean and comfortable. Highly recommended service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "Our weekend trip from Mumbai to Daman with Omshree Cabs was fantastic. Smooth driving, transparent pricing, and excellent service made the journey very enjoyable.",
    rating: 5
  }
];






















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Daman Taxi",
  "description": "Book Mumbai to Daman Taxi with Omshree Cab for safe and comfortable outstation travel. Reliable cab service from Mumbai to Daman with options for one-way trips. Affordable fares, easy online booking, and trusted taxi service for your Daman journey.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2100"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Mumbai to Daman Taxi | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Daman Taxi with Omshree Cab for comfortable travel. Taxi service from Mumbai to Daman with one-way options. Affordable fares and easy online cab booking for your Daman trip." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/24.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitodamantaxi;